export default "__VITE_ASSET__DRleNHZn__"